import React from 'react';
import dayjs from 'dayjs';

import DayItem from '@r1-frontend/service-engineer-visit/components/DayItem';
import { TDay } from '@r1-frontend/service-engineer-visit/reducer/initialState';

import Button from '@r1-frontend/ui-react/components/buttons/button';
import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { WithSkeleton } from '@r1-frontend/ui-react/components/loaders/Skeleton';
import Scrollable from '@r1-frontend/ui-react/components/Scrollable';
import { SingleArrowRight } from '@r1-frontend/ui-react/components/svg/arrows';
import { H4 } from '@r1-frontend/ui-react/components/typography/heading';
import { Paragraph4 } from '@r1-frontend/ui-react/components/typography/paragraph';
import TextWrapper from '@r1-frontend/ui-react/components/typography/TextWrapper';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { useMatchMedia } from '@r1-frontend/shared/hooks/useMatchMedia';

import * as S from './styled';

const formatCurrentDateString = () => {
    return `Сегодня ${dayjs(new Date(), { locale: 'ru' }).format('DD MMMM')}`;
};

type TDateSelectionProps = {
    slots: TDay[],
    selectedDate?: string,
    handleSelectDate: (date: string) => () => void,
    handleMore: () => void,
    requestedDays: number,
    moreButtonIsDisabled: boolean,
}

const DateSelection = ({ slots, selectedDate, handleSelectDate, handleMore, requestedDays, moreButtonIsDisabled }: TDateSelectionProps): JSX.Element => {
    const isMobile = useMatchMedia(`(max-width: ${wideBreakpoints.mobile})`);

    return (
        <S.Block>
            <TextWrapper>
                <H4 $smaller $withIndent={false}>Дата</H4>
                <Paragraph4 $color={COLORS.TextInfo} $smaller>{formatCurrentDateString()}</Paragraph4>
            </TextWrapper>
            <S.DaysSection>
                <WithSkeleton width={isMobile ? 300 : '100%'} height={90} inline>
                    <>
                        <Scrollable scrollToEnd={requestedDays > 7}>
                            <S.DaysWrapper>
                                {slots.map(day => (
                                    <React.Fragment key={`timeSlots-day-${day.day}`}>
                                        {day.isFirstDate && (
                                            <Paragraph4 style={{ padding: '0 8px' }} key={`timeSlots-month-name${day.day}`}>
                                                {dayjs(day.date.split('.').reverse().join(','), { locale: 'ru' }).format('MMMM')}
                                            </Paragraph4>
                                        )}
                                        <DayItem
                                            key={`timeSlots-day-${day.day}`}
                                            onClick={handleSelectDate(day.date)}
                                            day={day.day}
                                            weekday={day.weekday}
                                            $selected={day.date === selectedDate}
                                        />
                                    </React.Fragment>
                                ))}
                            </S.DaysWrapper>
                        </Scrollable>
                        <Button
                            data-testid='more-button'
                            bType={'secondary'}
                            rounded={true}
                            Icon={<SingleArrowRight type={'info'} />}
                            onClick={handleMore}
                            disabled={moreButtonIsDisabled}
                        />
                    </>
                </WithSkeleton>
            </S.DaysSection>
        </S.Block>
    );
};

export default DateSelection;
